/* eslint-disable */
export default {
  monday: 'M',
  tuesday: 'D',
  wednesday: 'W',
  thursday: 'D',
  friday: 'V',
  saturday: 'Z',
  sunday: 'Z',
} as const;

// @key: @#@"monday"@#@ @source: @#@"M"@#@
// @key: @#@"tuesday"@#@ @source: @#@"T"@#@
// @key: @#@"wednesday"@#@ @source: @#@"W"@#@
// @key: @#@"thursday"@#@ @source: @#@"T"@#@
// @key: @#@"friday"@#@ @source: @#@"F"@#@
// @key: @#@"saturday"@#@ @source: @#@"S"@#@
// @key: @#@"sunday"@#@ @source: @#@"S"@#@
